import { useState } from 'react';
import {
  TreeViewStateContextProvider,
  TreeViewSettersContextProvider,
} from './context';
import type { TreeViewContextProps as ContextProps } from './types';

export const TreeViewProvider = ({ children, value: _value }: ContextProps) => {
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  return (
    <TreeViewStateContextProvider value={selectedValues}>
      <TreeViewSettersContextProvider value={setSelectedValues}>
        {children}
      </TreeViewSettersContextProvider>
    </TreeViewStateContextProvider>
  );
};
